import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Stack, Typography, useMediaQuery } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import ActionsAutocompleteFormField from 'components/pricing/Services/edit-service/ActionsAutocompleteFormField'
import CancelButton from 'components/buttons/CancelButton'
import SaveButton from 'components/buttons/SaveButton'
import T from 'T'

const EventActionBar = ({
  control,
  getAvailableActionsForEvent,
  selectedDate,
  isAddingEvent,
  hasItemsMarkedForDeletion,
  hasEditableItems = false,
  pendingDeletionCount,
  isMutationLoading,
  onCancel,
  onSave,
  autocompleteSlotProps,
  showAddEventButton = false,
  onAddEvent,
}) => {
  const isNarrowLg = useMediaQuery('(min-width:1350px) and (max-width:1400px)')

  const responsiveSx = {
    flexDirection: isNarrowLg ? 'column' : { xs: 'column', md: 'row' },
    alignItems: isNarrowLg ? 'stretch' : { xs: 'stretch', md: 'flex-start' },
  }
  const buttonBoxSx = { height: '40px', justifyContent: isNarrowLg ? 'space-between' : undefined }

  return (
    <>
      {showAddEventButton && (
        <Button
          fullWidth
          startIcon={<AddIcon />}
          variant="outlined"
          size="small"
          sx={{ mt: 2, mb: 0, height: '40px' }}
          onClick={onAddEvent}
        >
          {T.EVENT}
        </Button>
      )}
      {(hasItemsMarkedForDeletion || isAddingEvent || hasEditableItems) && (
        <Stack direction="row" alignItems="center" spacing={1} mt={2} sx={responsiveSx}>
          {isAddingEvent && !hasItemsMarkedForDeletion && (
            <Box flexGrow={1}>
              <ActionsAutocompleteFormField
                name="action"
                control={control}
                options={getAvailableActionsForEvent(null, selectedDate) || []}
                fullWidth
                slotProps={autocompleteSlotProps}
              />
            </Box>
          )}
          {hasItemsMarkedForDeletion && (
            <Typography variant="body2" color="error" flexGrow={1}>
              {`${pendingDeletionCount} ${pendingDeletionCount === 1 ? 'event' : 'events'} pending deletion`}
            </Typography>
          )}
          <Box display="flex" alignItems="center" spacing={1} sx={buttonBoxSx}>
            <CancelButton size="small" disabled={isMutationLoading} onClick={onCancel} />
            <SaveButton size="small" loading={isMutationLoading} disabled={isMutationLoading} onClick={onSave} />
          </Box>
        </Stack>
      )}
    </>
  )
}

EventActionBar.propTypes = {
  control: PropTypes.object.isRequired,
  getAvailableActionsForEvent: PropTypes.func.isRequired,
  selectedDate: PropTypes.any,
  isAddingEvent: PropTypes.bool,
  hasItemsMarkedForDeletion: PropTypes.bool,
  hasEditableItems: PropTypes.bool,
  pendingDeletionCount: PropTypes.number,
  isMutationLoading: PropTypes.bool,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  autocompleteSlotProps: PropTypes.object,
  showAddEventButton: PropTypes.bool,
  onAddEvent: PropTypes.func,
}

export default EventActionBar
